// src/config.js
const AppConfig = {
    title: "hdjdnd",
    paragraph: "Bdjdn",
    img: "https://i.postimg.cc/6q4xSPKy/Screenshot-2026-01-12-133226.png",
    url: "hdjdnd",
    id: "633784"
};

export default AppConfig;